// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as SidebarManager from "./sidebars/SidebarManager.bs.js";
import * as Navbar$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as CorePricingTable from "./CorePricingTable.bs.js";
import * as CorePricingProvider from "../library/core-pricing-context/CorePricingProvider.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CorePricingFilterSection from "./CorePricingFilterSection.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";

function PricingDashboardComponent(Props) {
  var geo_regions = Props.geo_regions;
  var role = Props.role;
  var selected_geo_region = Props.selected_geo_region;
  var vehicle_types = Props.vehicle_types;
  var selected_vehicle_type = Props.selected_vehicle_type;
  var campaigns = Props.campaigns;
  var changeVehicleSelection = Props.changeVehicleSelection;
  var active_campaign = Props.active_campaign;
  var refetch_core_pricings = Props.refetch_core_pricings;
  var match = SidebarManager.useSidebar(undefined);
  var toggleSidebar = match[1];
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(undefined, undefined, undefined);
  var match$2 = React.useState(function () {
        return /* Active */0;
      });
  var region = List.find_opt((function (a) {
          return a.id === selected_geo_region;
        }), geo_regions);
  var region$1 = region !== undefined ? region : Curry._1(ErrorUtils$Catalyst.raiseError("PricingDashboardComponent.re", "Region not found L:27", undefined), undefined);
  var vehicle = List.find_opt((function (a) {
          return a.vehicle_id === selected_vehicle_type;
        }), vehicle_types);
  var match$3 = vehicle !== undefined ? vehicle : Curry._1(ErrorUtils$Catalyst.raiseError("PricingDashboardComponent.re", "Vehicle not found L:42", undefined), undefined);
  var getNavbarActions = function (role) {
    switch (role.TAG | 0) {
      case /* BusinessAdmin */0 :
      case /* CityAdmin */1 :
          break;
      case /* User */2 :
          return /* [] */0;
      
    }
    return {
            hd: {
              label: {
                TAG: /* Text */0,
                _0: "Create Core Pricing"
              },
              on_select_cb: (function (param) {
                  return Curry._1(toggleSidebar, (function (param) {
                                return {
                                        TAG: /* NewCampaign */1,
                                        _0: active_campaign,
                                        _1: campaigns
                                      };
                              }));
                }),
              icon: undefined
            },
            tl: /* [] */0
          };
  };
  return React.createElement(React.Fragment, undefined, React.createElement(CorePricingProvider.make, CorePricingProvider.makeProps({
                      openSnackbar: match$1[1],
                      geo_region: {
                        geo_region_id: selected_geo_region,
                        geo_region_name: region$1.name
                      },
                      vehicle_type: {
                        vehicle_id: selected_vehicle_type,
                        vehicle_name: match$3.vehicle.vehicle_type
                      },
                      refetch_core_pricings: refetch_core_pricings,
                      role: role,
                      setActiveTab: match$2[1]
                    }, null, undefined), React.createElement(Navbar$Catalyst.make, {
                      title: "Pricing Engine",
                      actions: getNavbarActions(role)
                    }), React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "pricing-dashboard-component"
                    }, React.createElement(CorePricingFilterSection.make, {
                          geo_regions: geo_regions,
                          selected_geo_region: selected_geo_region,
                          vehicle_types: vehicle_types,
                          selected_vehicle_type: selected_vehicle_type,
                          changeVehicleSelection: changeVehicleSelection
                        }), React.createElement(CorePricingTable.make, {
                          role: role,
                          campaigns: campaigns,
                          activeTab: match$2[0],
                          toggleSidebar: (function (sidebar) {
                              return Curry._1(toggleSidebar, (function (param) {
                                            return sidebar;
                                          }));
                            })
                        })), match[0], match$1[0]));
}

var make = PricingDashboardComponent;

export {
  make ,
  
}
/* react Not a pure module */
